module.exports = __webpack_public_path__ + "img/yyhb-logo.cc183844.png";